export enum ETipoAgendamento {
    Compromisso = 1,
    Tarefa = 2,
    Lembrete = 3,
    Evento = 4,
    Recorrente = 5
}
